import React from 'react';
import clsx from 'clsx';

interface FormFieldProps {
	label: string;
	htmlFor?: string;
	className?: string;
	error?: string;
	children: React.ReactNode;
}

export const FormField: React.FC<FormFieldProps> = ({ label, htmlFor, className, error, children }) => (
	<div className={clsx('cem-field', { 'cem-field--error': Boolean(error) }, className)}>
		<label
			className="cem-field__label"
			htmlFor={htmlFor}>
			{label}
		</label>
		{children}
		{error && (
			<span
				className="cem-field__error"
				role="alert">
				{error}
			</span>
		)}
	</div>
);

export default FormField;
